import React from "react";
import { Card, CardContent } from "../ui/card";
import InfoModal from "../InfoModal";
import BookServiceButton from "./BookServiceButton";
import { supportGroup, groupInterventions } from "../../data/servicesContent";

const GroupInterventionsSection = () => {
  return (
    <div className="space-y-10">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-3">
          Interventions de groupes
        </h2>
        <p className="font-accent italic text-xl text-[#4A4458] mb-3">
          Transformer la douleur en force collective !
        </p>
        {/* Texte issu de la plaquette (groupe de parole, p. 18-19) */}
        <p className="text-[#4A4458] leading-relaxed">
          Briser l'isolement, libérer la parole, tisser des liens avec des personnes
          qui vous ressemblent et vous soutiennent : les espaces collectifs sont des
          bulles où la diversité est une force.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Le groupe de parole intersectionnel — section N */}
        <Card className="overflow-hidden bg-[#FDFBF5] hover:shadow-xl transition-shadow">
          <img
            src={supportGroup.image.src}
            alt={supportGroup.image.alt}
            loading="lazy"
            className="w-full h-48 object-cover"
          />
          <CardContent className="p-6">
            <h3 className="font-accent font-semibold text-xl text-[#21167D] mb-2">{supportGroup.title}</h3>
            <p className="font-accent italic text-[#4A4458] mb-4">{supportGroup.subheading}</p>
            <p className="text-[#4A4458] mb-4 leading-relaxed line-clamp-4">{supportGroup.intro}</p>
            <p className="text-sm font-medium text-[#21167D] mb-6">{supportGroup.formats}</p>

            <InfoModal
              triggerLabel="En savoir plus"
              triggerClassName="w-full"
              title={supportGroup.title}
              subtitle={supportGroup.subheading}
              image={supportGroup.image}
            >
              <p>{supportGroup.intro}</p>
              <p>{supportGroup.paragraph2}</p>
              <p>{supportGroup.paragraph3}</p>

              <h4 className="font-semibold text-[#21167D] text-lg">{supportGroup.frameworkHeading}</h4>
              <ul className="list-disc list-inside space-y-2">
                {supportGroup.frameworkItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <p>{supportGroup.closing}</p>
              <p className="font-medium text-[#21167D]">{supportGroup.formats}</p>
              <p className="font-semibold text-[#21167D]">{supportGroup.nextSession}</p>
            </InfoModal>
            <BookServiceButton serviceId="groupe-de-parole" className="w-full mt-3" />
          </CardContent>
        </Card>

        {/* Autres interventions de groupes */}
        {groupInterventions.map((intervention) => (
          <Card key={intervention.id} className="overflow-hidden bg-[#FDFBF5] hover:shadow-xl transition-shadow">
            <img
              src="/seance-groupe.jpg"
              alt="Séance d'échange en petit groupe"
              loading="lazy"
              className="w-full h-48 object-cover"
            />
            <CardContent className="p-6 flex flex-col">
              <h3 className="font-accent font-semibold text-xl text-[#21167D] mb-2">{intervention.title}</h3>
              <p className="font-accent italic text-[#4A4458] mb-4">{intervention.subheading}</p>
              <p className="text-[#4A4458] mb-6 leading-relaxed">{intervention.description}</p>
              <InfoModal
                triggerLabel="En savoir plus"
                triggerClassName="w-full"
                title={intervention.title}
                subtitle={intervention.subheading}
              >
                <p>{intervention.description}</p>
                {intervention.details.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </InfoModal>
              <BookServiceButton serviceId="intervention-organisme" label="Demander une intervention" className="w-full mt-3" />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default GroupInterventionsSection;
